import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

const Education = ({ sectionName, education }) => {
    const Colleges = education.map((college, i) => {
        return (
            <VerticalTimelineElement
                className="vertical-timeline-element"
                date={college.years}
                dateClassName="text-black fs-5"
                iconStyle={{
                    background: '#635bff',
                    color: '#fff',
                    textAlign: 'center'
                }}
                icon={<span className="iconify" data-icon="map:university"></span>}
                key={i}
            >
                <h3 className="vertical-timeline-element-title" style={{ textAlign: 'left' }}>
                    {college.degree}
                </h3>

                <h4 className="vertical-timeline-element-subtitle" style={{ textAlign: 'left' }}>
                    {college.name}
                </h4>

                <p className="modal-description text-justified" style={{ fontSize: '120%' }}>
                    {college.graduation}
                </p>
                <p className="modal-description text-justified">{college.gpa}</p>
            </VerticalTimelineElement>
        );
    });
    return (
        <section id="resume" className="pb-5">
            <div className="col-md-12 mx-auto">
                <div className="col-md-12">
                    <h1 className="section-title" style={{ color: 'black' }}>
                        <span className="text-black" style={{ textAlign: 'center' }}>
                            {sectionName}
                        </span>
                    </h1>
                </div>
            </div>
            <div className="col-md-8 mx-auto">
                <VerticalTimeline animate={true}>
                    {Colleges}
                    <VerticalTimelineElement
                        iconStyle={{
                            background: '#635bff',
                            color: '#fff',
                            textAlign: 'center'
                        }}
                        icon={<span className="iconify" data-icon="vaadin:diploma-scroll"></span>}
                    />
                </VerticalTimeline>
            </div>
        </section>
    );
};

export default Education;
